import { render, staticRenderFns } from "./slider-icon.vue?vue&type=template&id=464bd42a&scoped=true&"
import script from "./slider-icon.vue?vue&type=script&lang=js&"
export * from "./slider-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bd42a",
  null
  
)

export default component.exports